// PX
export const HEADER_HEIGHT = 56
export const FOOTER_HEIGHT = 56

// VH
export const PROJECT_HEADER_HEIGHT_MOBILE = 30
export const PROJECT_HEADER_HEIGHT_DESKTOP = 60
